import "./header.styles.css";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import MobileMenu from "../mobileMenu/mobileMenu.component";
import Menu from "../../svg/menu";
import DropMenu from "../dropMenu/dropMenu.component";
import DropDwonArrow from "../../svg/dropdownArrow";
import MobileDropdown from "../mobileMenu/mobileMenuDropdown.component";

// 10-Year Anniversary Logo - High Quality
// Using Cloudinary optimization: q_100 (maximum quality), f_auto (auto format), dpr_auto (retina support)
const LOGO_URL = "https://res.cloudinary.com/dhbe6wtod/image/upload/q_100,f_auto,dpr_auto/v1771250399/healix/new%20logos/1OTH-blue_t8itk4_5ad7ba.png";

const Header = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showDropMenu, setShowDropMenu] = useState(false);
  const [showMobileDropdown, setShowMobileDropdown] = useState(false);

  const onMouse = () => {
    setShowDropMenu(!showDropMenu);
  };

  const onMouseLeave = () => {
    setTimeout(() => {
      setShowDropMenu(false);
    }, 2000);
  };

  const handleClose = () => {
    setShowMobileDropdown(false);
    setShowMobileMenu(false);
    setShowDropMenu(false);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setShowMobileDropdown(false);
        setShowMobileMenu(false);
        setShowDropMenu(false);
      }
      
      // Keyboard navigation for dropdown menu
      if (showDropMenu && e.key === 'ArrowDown') {
        e.preventDefault();
        const firstLink = document.querySelector('.drop-menu a');
        if (firstLink) {
          firstLink.focus();
        }
      }
    };

    if (showMobileMenu || showDropMenu || showMobileDropdown) {
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [showMobileMenu, showDropMenu, showMobileDropdown]);
  return (
    <>
      <a href="#main-content" className="skip-link" aria-label="Skip to main content">
        Skip to main content
      </a>
      <div className="main-header">
      <div className="nav">
        {" "}
        <Link to={"/"} className="header-logo" aria-label="Healix Medical homepage">
          <div>
            <img 
              src={LOGO_URL} 
              alt="Healix Medical logo - 10 Years of Excellence"
              loading="eager"
              fetchPriority="high"
            />
          </div>
        </Link>
        <div className="nav-list">
          <Link
            to={"/#banner"}
            className="nav-link"
            onMouseEnter={() => setShowDropMenu(false)}
          >
            Home
          </Link>
          <Link
            to={"/products"}
            className="nav-link products-dropdown"
            aria-haspopup="true"
            aria-expanded={showDropMenu}
            onMouseEnter={() => {
              setShowDropMenu(true);
            }}
            onMouseLeave={(e) => {
              // Only close if mouse is not moving to dropdown
              const relatedTarget = e.relatedTarget;
              const isMovingToDropdown = relatedTarget && 
                                         relatedTarget instanceof Element && 
                                         typeof relatedTarget.closest === 'function' &&
                                         relatedTarget.closest('.drop-menu');
              
              if (!isMovingToDropdown) {
                setTimeout(() => {
                  setShowDropMenu(false);
                }, 100);
              }
            }}
          >
            Featured Products <DropDwonArrow />
          </Link>
          <Link
            to={"/services"}
            className="nav-link"
            onMouseEnter={() => setShowDropMenu(false)}
          >
            Services
          </Link>
          <Link 
            to={"/about"} 
            className="nav-link"
            onMouseEnter={() => setShowDropMenu(false)}
          >
            About us
          </Link>
          <Link 
            to={"/blogs"} 
            className="nav-link"
            onMouseEnter={() => setShowDropMenu(false)}
          >
            Blog
          </Link>
          <Link to={"/contact/#contact"} className="nav-link">
            Contact us
          </Link>
        </div>
        <div className="ham-menu">
          <button
            onClick={() => setShowMobileMenu(!showMobileMenu)}
            className="menu-icon"
            aria-label="Toggle mobile menu"
            aria-expanded={showMobileMenu}
            aria-controls="mobile-menu"
            type="button"
          >
            <Menu />
          </button>
          <span className="menu-title">Menu</span>
        </div>
        {showMobileMenu && !showMobileDropdown && (
          <>
            <div 
              className="mobile-menu-backdrop active"
              onClick={handleClose}
              aria-hidden="true"
            />
            <MobileMenu
              setShowMobileMenu={setShowMobileMenu}
              setShowMobileDropdown={setShowMobileDropdown}
              handleClose={handleClose}
              showMobileMenu={showMobileMenu}
              showMobileDropdown={showMobileDropdown}
            />
          </>
        )}
        {showDropMenu && (
          <DropMenu
            showDropMenu={showDropMenu}
            setshowDropMenu={setShowDropMenu}
            handleClose={handleClose}
            id="products-dropdown"
          />
        )}
        {showMobileDropdown && (
          <>
            <div 
              className="mobile-menu-backdrop active"
              onClick={handleClose}
              aria-hidden="true"
            />
            <MobileDropdown
              setShowMobileDropdown={setShowMobileDropdown}
              setShowMobileMenu={setShowMobileMenu}
              handleClose={handleClose}
              showMobileDropdown={showMobileDropdown}
            />
          </>
        )}
      </div>
      </div>
    </>
  );
};

export default Header;
